import { Cpu, HardDrive, Boxes, Brain, Globe2, Coins } from "lucide-react";

const PILLARS = [
    { icon: Cpu, k: "Compute", v: "Containerized workloads across global nodes." },
    { icon: HardDrive, k: "Storage", v: "Encrypted + erasure-coded + Proof of Storage." },
    { icon: Boxes, k: "Layer-1", v: "EVM-compatible DPoS-BFT settlement chain." },
    { icon: Brain, k: "AI", v: "Decentralized GPU scheduling & inference." },
    { icon: Globe2, k: "DNS", v: "On-chain naming and routing." },
    { icon: Coins, k: "Economy", v: "Protocol-level developer revenue share." },
];

export default function SolutionOverview() {
    return (
        <section className="relative py-16 sm:py-24 md:py-32 border-t border-line" data-testid="solution-overview">
            <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
                <div className="grid lg:grid-cols-12 gap-8 sm:gap-10 items-start">
                    <div className="lg:col-span-5">
                        <div className="overline mb-4">02 — Solution Overview</div>
                        <h2 className="font-heading font-black text-[1.85rem] sm:text-4xl lg:text-5xl leading-[1.06] tracking-tight text-ink">
                            One Protocol.<br />
                            <span className="brand-gradient-text">Six Coordinated Layers.</span>
                        </h2>
                        <p className="mt-5 sm:mt-6 text-[15px] sm:text-base text-muted-ink leading-relaxed">
                            DeCloudX vertically integrates compute, storage, AI, DNS, settlement, and the developer economy into a single programmable cloud protocol — coordinated by a Layer-1 EVM chain.
                        </p>
                    </div>
                    <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {PILLARS.map((p, i) => (
                            <div key={i} className="surface p-4 sm:p-5 rounded-xl flex items-start gap-3" data-testid={`solution-pillar-${i}`}>
                                <div className="w-9 h-9 rounded-lg bg-card-muted border border-line flex items-center justify-center shrink-0">
                                    <p.icon size={16} className="text-brand-cyan" strokeWidth={1.5} />
                                </div>
                                <div>
                                    <div className="font-heading font-bold text-[15px] sm:text-base text-ink">{p.k}</div>
                                    <div className="text-xs text-muted-ink mt-1 leading-relaxed">{p.v}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
